import { render } from "./GalleryPhoto.vue?vue&type=template&id=4bde7ca0&scoped=true"
import script from "./GalleryPhoto.vue?vue&type=script&lang=js"
export * from "./GalleryPhoto.vue?vue&type=script&lang=js"

import "./GalleryPhoto.vue?vue&type=style&index=0&id=4bde7ca0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bde7ca0"]])

export default __exports__